import PricingPlans from './PricingPlans';

export default PricingPlans;
